module.exports = __webpack_public_path__ + "static/media/boy-large.e514224e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Age/boy-large.svg
// module id = 393
// module chunks = 0